 

/**
 * index of article titles and ids
 * the title doesn't have to match the real title exactly
 * just a memorable title that can be used to look up the hash id
 * this list should only include titles we actually use in the lists below
 * comment out unused titles to prevent test failures
 */
const index = {
    "Add email sig gmail": "5b3185260428632c466b5218",
    "Add www": "5b3185390428632c466b525f",
    "All about spotlight": "5bae4d94042863158cc6dfbe",
    // "Already bought domain": "5bb296c32c7d3a04dd5b2bcc",
    "Best link for spotlight": "5bae5658042863158cc6e023",
    // "Best plan for you": "5bb26af8042863158cc6f0cd",
    // "Can I map domain": "5bb296c32c7d3a04dd5b2bcc",
    "Change domain": "5b31852d0428632c466b5230",
    // "Change email pref": "5b98518a2c7d3a03f89eaf67",
    "Change username": "5bb2af28042863158cc6f366",
    "Choosing spotlight": "5bae55c6042863158cc6e01a",
    "Connecting godaddy domain": "5b71affa2c7d3a03f89da350",
    "Delete page": "5b31852d2c7d3a0fa9a36f61",
    "Enom": "5b71af682c7d3a03f89da347",
    "General using own domain": "5b3185372c7d3a0fa9a36f7f",
    "Get https for domain": "5b3185390428632c466b5261",
    "Hover": "5b9816fb0428631d7a8afb4f",
    "More customized spotlight": "5b31852f2c7d3a0fa9a36f68",
    "Multiple domains": "5b9852b92c7d3a03f89eaf77",
    "Namecheap": "5b9815d20428631d7a8afb35",
    "Quick edit guide": "5b7c775d2c7d3a03f89df5e9",
    "Remove chrome ext.": "5b3185302c7d3a0fa9a36f6c",
    "Remove gmail sig": "5b3185342c7d3a0fa9a36f75",
    "Sig photo doesn't show": "5b3185332c7d3a0fa9a36f70",
    "Transfer domain": "5b3185120428632c466b51ee",
    // "What domains are available": "5bb293672c7d3a04dd5b2bb4",
    "What is spotlight": "5bae54422c7d3a04dd5b1813",
    // "What's customer support": "5bb29c182c7d3a04dd5b2bfe",
    // "What's remove branding": "5bb2974c042863158cc6f2b4",
    "Where share link": "5b3185350428632c466b5250",
    "Which plan is best for me": "5bb292c72c7d3a04dd5b2bac",
    "Why about.me": "5bb297db042863158cc6f2b8",
    "Why email sig": "5bb2a6d7042863158cc6f33f",
    // "Why share page": "5b3185402c7d3a0fa9a36f9a",
    "Write great bio": "5bac2dc52c7d3a04dd5b03fe",
}

/**
 * lists of suggestions for various scenarios
 * all the titles in the lists below must match titles in the index above
 * (there is a karma test on this module which will double-check :)
 */
const lists = {}

lists.bio_pane = [
    "Write great bio",
]

lists.email_signature_pane = [
    "Why email sig",
    "Add email sig gmail",
    "Remove chrome ext.",
    "Remove gmail sig",
    "Sig photo doesn't show",
    "Where share link",
]

lists.spotlight_pane = [
    "What is spotlight",
    "Choosing spotlight",
    "Best link for spotlight",
    "More customized spotlight",
    "All about spotlight",
    "Quick edit guide",
]

lists.dns_connect_pane = [
    "Connecting godaddy domain",
    "Get https for domain",
    "Add www",
    "Multiple domains",
    "Change domain",
    "Transfer domain",
]

lists.dns_settings_pane = [
    "General using own domain",
    "Connecting godaddy domain",
    "Enom",
    "Namecheap",
    "Hover",
    "Get https for domain",
    "Add www",
    "Multiple domains",
    "Transfer domain",
]

lists.profile_free = [
    "Quick edit guide",
    "Which plan is best for me",
    "Why about.me",
    "Change username",
    "Delete page",
]
lists.profile_pro = [
    "Write great bio",
    "Quick edit guide",
    "Why email sig",
    "Where share link",
    "Change domain",
]

/** =========================================
 * do not write below this line
 * for office use only
 * =========================================*/

// create lists of ids using the titles above
const suggestions = {}
Object.keys(lists).forEach(list => {
    suggestions[list] = lists[list].map(title => index[title])
})

module.exports = {
    index,
    lists,
    suggestions,
}
